module.exports = __webpack_public_path__ + "img/base_activites_ski_nautique.8e813e9e.svg";